export const employmentContract = {
  // Page
  CREATE_EMPLOYMENT_CONTRACT: 'Skapa anställningsavtal',
  SIGNATURES: 'Signaturer',

  // Employer Information section
  EMPLOYER_INFORMATION: 'Arbetsgivarinformation',
  EMPLOYEE_INFORMATION: 'Anställningsinformation',
  COMPANY: 'Företag',
  ORGANISATION_NUMBER: 'Organisationsnummer',
  ADDRESS: 'Adress',
  ZIP_CODE: 'Postnummer',
  COUNTRY: 'Land',
  PHONE_NUMBER: 'Telefonnummer',

  // Employee Information section
  FULL_NAME: 'Fullständigt namn',
  SOCIAL_SECURITY_NUMBER: 'Personnummer',
  EMAIL: 'E-post',
  CITY: 'Stad',
  POSTAL_CODE: 'Postnummer',
  ACCOUNT_SETTINGS: 'Kontoinställningar',

  // Signature sections
  ON_BEHALF_OF_EMPLOYER: 'På uppdrag av den anställde:',
  ON_BEHALF_OF_INVOZIO: 'På uppdrag av Invozio LV SIA:',
  DATE: 'Datum',
  PLACE: 'Ort',
  SIGNATURE: 'Underskrift',
  DRAW_SIGNATURE: 'Rita underskrift',
  UPLOAD_SIGNATURE: 'Ladda upp underskrift',
  CLICK_DRAW_TO_SIGN: 'Klicka på "Rita underskrift" för att signera här',
  EC_SIGNATURE_UPLOAD_INFO: 'Rita din underskrift i rutan, eller ladda upp en som PNG- eller JPG-bild (max 1 MB).',
  EC_ERROR_SIGNATURE_FORMAT: 'Signaturbilden måste vara en PNG- eller JPEG-fil. Konvertera bilden innan du laddar upp.',
  CLEAR: 'Rensa',
  NAME_CLARIFICATION: 'Namnförtydligande',
  ENTER_NAME_CLARIFICATION: 'Ange namnförtydligande...',
  INVOZIO_SIGNER_TITLE: 'HR-kock',
  DIGITALLY_PRE_SIGNED: 'Digitalt förtecknat',
  NO_SIGNATURE_YET: 'Ingen underskrift har angetts ännu',

  // Footer
  CANCEL: 'Avbryt',
  SUBMIT: 'Skicka in',

  // Validation
  EC_VALIDATION_DATE_REQUIRED: 'Datum är obligatoriskt',
  EC_VALIDATION_SIGNATURE_REQUIRED: 'Underskrift är obligatorisk',
  EC_VALIDATION_NAME_CLARIFICATION_REQUIRED: 'Namnförtydligande är obligatoriskt',
  CONTRACT_SUBMITTED_SUCCESS: 'Anställningsavtalet har skickats in!',
  DOWNLOAD_EMPLOYMENT_CONTRACT: 'Ladda ner anställningsavtal',
};
